import "./style/index.css";
import AllRoutes from "./routes";
import { CookiesProvider } from "react-cookie";
import "react-quill/dist/quill.snow.css";

function App() {
  return (
    <CookiesProvider>
      <AllRoutes />
    </CookiesProvider>
  );
}

export default App;
